<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="navbar"
    >
    <van-icon name="descending" size=".5rem" slot="right" />
    </van-nav-bar>
    <van-row class="table-header fixed">
      <van-col span="18">名称</van-col>
      <van-col span="6">数量</van-col>
    </van-row>
    <div class="content-scroll-list-wrap table-header-navbar" ref="scrollWrapper">
      <div class="nodata" v-if="!list.length">没有到任何数据!</div>
      <cube-scroll
        ref="contentScroll"
        :data="list"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <van-checkbox-group v-model="selected">
          <van-row class="table-list-data" v-for="(item,index) in list">
            <van-col span="18">{{item.title}}</van-col>
            <van-col span="6">x{{item.num}}</van-col>
          </van-row>
        </van-checkbox-group>
      </cube-scroll>
    </div>
    <!-- <div class="footer-navbar">
      <van-button type="danger" class="op-delete" @click="onDelete">删除</van-button>
    </div>-->
  </div>
</template>

<script>
import { OrderModel } from "@models/common/order";
import { ERR_OK } from "@/common";
const orderModel = new OrderModel();

export default {
  data() {
    return {
      list: [],
      title: "订单汇总",
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 1000,
          txt: "更新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      },
      selected: [],
      totalpage: 1,
      page: 1,
      merchname: '',
      parentid: 0,
      exportdata: []
    };
  },
  methods: {
    onClickLeft() {
      this.$redirect("/home/index");
    },
    onClickRight() {
      this._exportToExcel()
    },
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.page++;
          this.getData();
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      let params = {};
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.getData();
      }, 1000);
    },
    getData() {
      orderModel
        .getHomeSummary({
          merchid: localStorage.id,
          page: this.page
        })
        .then(res => {
          if (ERR_OK == res.code) {
            this.totalpage = res.data.list.last_page;
            this.exportdata = res.data.export
            this.list = this.list.concat(res.data.list.data);
          }
        });
    },
    _exportToExcel() {
		  require.ensure([], () => {
		 		const { export_json_to_excel } = require('@vendor/Export2Excel');
		 		const tHeader = this.exportdata.tHeader //对应表格输出的title
				const filterVal = this.exportdata.filterVal; // 对应表格输出的数据
				const list = this.list;
				const data = this.formatJson(filterVal, list);
				export_json_to_excel(tHeader, data, '汇总excel'); //对应下载文件的名字
		  })
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]))
		},
  },
  created() {
    this.getData();
  }
  
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.navbar {
  color: #fff;
  background: #2196f3;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.content-scroll-list-wrap img {
  max-width: 100%;
}

>>>.table-header {
  top: 0.92rem;
}

>>>.content-scroll-list-wrap.table-header-navbar {
  top: 1.7rem;
  height: calc(100% - 1.72rem);
}
</style>
